export enum ClassifierType {
  Terrestrial = 'terrestrial',
  Aerial = 'aerial',
}

export const DEFAULT_CLASSIFIER_TYPE = ClassifierType.Terrestrial;

export interface Classifier {
  id: string;
  name: ClassifierType;
}
